import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TimeSelect extends Component {
  static propTypes = {
    useTimezone: PropTypes.string,
    no_blank_option: PropTypes.bool,
    id_time_map: PropTypes.array,
    name: PropTypes.string,
  }

  static defaultProps = {
    useTimezone: moment.tz.guess(),
  }

  render() {
    return (
      <select name={this.props.name} >
        {this.props.no_blank_option ? '' : <option />}
        {this.props.id_time_map.map((option) => {
          const displayValue = moment(option.value).tz(this.props.useTimezone).format('h:mm A');

          return (
            <option selected={option.selected ? 'selected' : null} value={option.key} key={`opt-${option.key}`}>
              {displayValue}
            </option>
          );
        })}
      </select>
    );
  }
}
